import { useEffect } from "react";

import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { AboutComponent } from "../../components/info/AboutComponent";
import { ContainerComponent } from "../../components/ui";
import { setShowSearch } from "../../store/appConfigsSlice";

const AboutPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowSearch(false));
  }, []);

  return (
    <ContainerComponent>
      <AboutComponent />
    </ContainerComponent>
  );
};

export default withTranslation()(AboutPage);
